import gql from 'graphql-tag';

const actionLogMutation = gql`
  mutation Log($nodeId: String, $type: LOG_TYPE) {
    Log(nodeId: $nodeId, type: $type) {
      success
    }
  }
`;

export const userActionTypes = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  UPLOAD: 'UPLOAD',
};

export function userActionLog(variables, client) {
  client
    .mutate({
      mutation: actionLogMutation,
      variables: { nodeId: variables.id, type: variables.type },
    })
    .then(({ data }) => {
      console.log('got data', data);
    })
    .catch((error) => {
      console.log('there was an error sending the query', error);
    });
}
